var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72717 13.5012C1.259 13.5012 0.854093 13.3272 0.512456 12.9792C0.170819 12.6313 0 12.2295 0 11.774V2.24614C0 1.79063 0.170819 1.38573 0.512456 1.03144C0.854093 0.677145 1.259 0.5 1.72717 0.5H14.2539C14.722 0.5 15.1301 0.677145 15.4781 1.03144C15.826 1.38573 16 1.79063 16 2.24614V11.774C16 12.2295 15.826 12.6313 15.4781 12.9792C15.1301 13.3272 14.722 13.5012 14.2539 13.5012H1.72717ZM7.99051 7.71234C8.06643 7.71234 8.13919 7.70285 8.20878 7.68387C8.27837 7.66489 8.36378 7.62376 8.46501 7.5605L14.0071 3.85943C14.0704 3.82147 14.1273 3.76137 14.1779 3.67912C14.2285 3.59688 14.2539 3.49249 14.2539 3.36596C14.2539 3.17616 14.1526 3.0085 13.9502 2.86299C13.7477 2.71748 13.5516 2.72064 13.3618 2.87248L7.99051 6.38375L2.65718 2.87248C2.45473 2.74595 2.24911 2.73962 2.04033 2.8535C1.83155 2.96738 1.72717 3.1382 1.72717 3.36596C1.72717 3.47983 1.75563 3.5779 1.81257 3.66014C1.86951 3.74239 1.92962 3.80882 1.99288 3.85943L7.51601 7.5605C7.61724 7.62376 7.70265 7.66489 7.77224 7.68387C7.84184 7.70285 7.91459 7.71234 7.99051 7.71234Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.047c06b0975000d2ea39510fac537641.svg";
export { ForwardRef as ReactComponent };